<template>
  <div class="animated fadeIn">
    <loader :show="enviando"/>
    <b-card>
        <h4 slot="header" class="card-title mb-0">{{nombre}}</h4>
        <b-row>
            <b-col sm="12">
                El Presupuesto Participativo es un ejercicio que, por medio de una consulta, permite a la ciudadanía elegir y decidir qué obras o proyectos
                se realizarán con una parte de los recursos municipales.
                <br><br>
                <b>Elige {{opciones}} obras, las que consideres más necesarias realizar en la zona donde habitas. </b>
                <br><br>
            </b-col>
            <b-col sm="12" md="12"
                v-for="(item, index) in delegaciones" :key="index">
                <b-form-group>
                    <b-form-checkbox-group v-model="selected">
                            <b-card>
                                <h6 slot="header" class="card-title mb-0">{{item.nombre}}</h6>
                                <b-list-group>
                                    <b-list-group-item v-for="(obra, index2) in item.obras" :key="index2">
                                        <div class="d-flex w-100 justify-content-star">
                                            <b-form-checkbox :value="obra._id" :disabled="!disponible(obra._id)"></b-form-checkbox>
                                            <h5 >{{obra.titulo}}</h5>
                                        </div>
                                        <small class="text-muted">{{obra.subtitulo}}</small>
                                    </b-list-group-item>
                                </b-list-group>
                            </b-card>
                    </b-form-checkbox-group>
                </b-form-group>
            </b-col>
            <b-col md="12">
                <div class="d-flex w-100 justify-content-between">
                    <b-button variant="primary" :disabled="selected.length < opciones" @click="guardarVoto()">
                        Guardar voto
                    </b-button>
                </div>
            </b-col>
            <b-col sm="12">
                <br>
                <b-alert variant="danger" v-model="error" dismissible>{{errorMsj}}</b-alert>
            </b-col>
        </b-row> 
    </b-card>
  </div>
</template>

<script>
import axios from 'axios'
import Loader from './Loader'
import { mapGetters } from "vuex";
import moment from 'moment'
moment.locale('es');

export default {
    props: ['encuesta', 'cuenta', 'token'],
  components: {
   Loader
  },
  computed: {
        ...mapGetters([
          "httpURL",
          "sessionToken",
          "permisos",
          "role",
          "tableProps"
        ])
    },
  data: function () {
    return {
      enviando: false,
      idEncuesta: null,
      nombre: 'Presupuesto participativo',
      delegaciones: [],
      selected: [],
      opciones: 0,
      error: false,
      errorMsj: ''
    }
  },
  created(){
    // this.enviandoStart();
    this.idEncuesta = this.encuesta._id;
    this.nombre = this.encuesta.nombre;
    this.delegaciones = this.encuesta.delegaciones;
    this.opciones = this.encuesta.opciones;
  },
  methods: {
    enviandoStart(){
        this.enviando = true;
    },
    enviandoStop(){
        this.enviando = false;
    },
    disponible(idObra){
        if( this.selected.findIndex(x=>x == idObra) >= 0)
            return true;
        else{
            return this.selected.length < this.opciones;
        }
    },
    guardarVoto(){
        if( !this.cuenta ){
            this.errorMsj = 'Debe ingresar una cuenta';
            this.error = true;
        }else{
            this.enviandoStart();
            this.$emit('realizarPago');
            axios.post(this.httpURL+'/encuestas/presupuesto/'+this.idEncuesta,
                {cuenta: this.cuenta, opciones: this.selected.toString(), ambiente: 'Pago online', token:this.token}
                )
                .then(res => {
                    this.enviandoStop();
                })
                .catch(error => {
                // console.log(error);
                    this.enviandoStop();
                    if(error.res){
                        this.$notify({ group: 'foo', type:"error", duration:2500, speed: 1000,
                                text: error.res.data.mensaje });
                    }else if( error.request){
                        this.$notify({ group: 'foo', type:"error", duration:1500, speed: 1000,
                                text: 'No se pudo establecer una conexión al servidor.' });
                    }
                });
        }
    }
  }
}
</script>

<style>
  /* IE fix */
  #card-chart-01, #card-chart-02 {
    width: 100% !important;
  }
</style>
